// Entrega uma URI de protocolo externo (sip:) ao sistema operacional.
//
// IMPORTANTE — precisa rodar no MESMO TURNO SÍNCRONO do clique do usuário.
// Qualquer `await` antes daqui faz o Chrome perder a ativação do gesto e o lançamento de
// protocolo externo é bloqueado SEM erro, sem log, sem nada. É por isso que o caminho
// softphone do useCallProvider não tem await antes de chamar esta função.
//
// Por que âncora e não as alternativas:
//   window.location.assign('sip:…') → dispara o ciclo de unload do documento: cancela
//     fetch/XHR em voo, roda beforeunload e confunde listeners de popstate do router.
//   iframe.src = 'sip:…'           → padrão legado de IE; o Chrome moderno bloqueia
//     lançamento de protocolo a partir de subframe.
//
// Não existe forma de saber se o handler está instalado: não há evento de erro, e
// heurísticas de blur/visibilitychange dão falso positivo (quando o usuário já marcou
// "sempre permitir", o foco pode não sair da aba) e falso negativo. Quem chama assume
// sucesso e oferece o número para copiar. Não tente detectar.

export function openExternalUri(uri: string): void {
  const a = document.createElement('a');
  a.href = uri;
  a.rel = 'noopener noreferrer';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // Remover no mesmo tick pode abortar o handoff em alguns builds do Chrome.
  requestAnimationFrame(() => a.remove());
}
